import { Dispatch, SetStateAction } from 'react';

import { v4 as uuid } from 'uuid';

import { ICollaboratorsEmailData } from '../../interfaces/collaborators';
import { validateEmail } from '../validation/validation';

const validateEmailList = (emails: Array<ICollaboratorsEmailData>, emailList: string[]) => {
  const uniqueEmailList = [...new Set(emailList)];
  const emailsTo = uniqueEmailList
    .filter((email) => !isInList(emails, email))
    .map((email) => ({
      emailString: email,
      isValidEmail: validateEmail(email, true)
    }));

  return emailsTo;
};

const isInList = (emails: Array<ICollaboratorsEmailData>, email: string) => {
  return !!emails.find((item) => item.emailString === email);
};

export const handleOnPaste = (
  event: React.ClipboardEvent,
  emails: Array<ICollaboratorsEmailData>,
  setEmails: Dispatch<SetStateAction<ICollaboratorsEmailData[]>>
) => {
  event.preventDefault();
  const pasteContent = event.clipboardData.getData('text').toLowerCase();
  const splitsContent = pasteContent.split(/[\s,]+/);
  const verifyWhiteSpaces = validateEmailList(emails, splitsContent);
  const emailsToBeAdded = verifyWhiteSpaces.filter((email) => email.emailString !== '');
  const emailsWithIds = emailsToBeAdded.map((email) => ({ ...email, id: uuid() }));

  if (emailsToBeAdded.length > 0) {
    setEmails([...emails, ...emailsWithIds]);
  }
};

export const addEmailInState = (
  emails: Array<ICollaboratorsEmailData>,
  email: string,
  setEmails: Dispatch<SetStateAction<ICollaboratorsEmailData[]>>,
  setValue: Dispatch<SetStateAction<string>>
) => {
  if (!isInList(emails, email)) {
    setEmails([...emails, { emailString: email, isValidEmail: validateEmail(email, true), id: uuid() }]);
  }
  setValue('');
};

export const handleChange = (
  evt: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
  setValue: Dispatch<SetStateAction<string>>
) => {
  setValue(evt.target.value);
};
